import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { useLocation } from "react-router-dom";
import LottieAnimation from "../LottieAnimation";
import PaymentProcessing from "../../Payment_Processing.json";

const CartDetails = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [value, setValue] = React.useState(true);

  // payment integration
  const makePayment = async () => {
    setValue(true);
    console.log("payment :::");
    const id = queryParams.get("id");
    console.log("id :::", id);

    // pk_test_51KQtGkJwNyaUeYQPTiD6ES16EEKmNu3hoaOhBz4XuWKprvS0kBJlGaXrCTXBwCMeGRa2xwTr4w08mGvJdVNEN89u00oSd7bYZU
    // pk_live_51NDXuOI6tTYDPEyAFnbAEJ58SkcVi1PgpaHyUjjxjPYcg6lsvo6tA9vuMUDGwZBTCEdLXxBfDX7r4FhhqgeMCfvP00dHFiYmKH
    // sk_test_51KQtGkJwNyaUeYQPpE48slh9uwRVg3SpR8SvzyEqVYewR7nFLZpTtwXTIspb8jHO7rzMFv23eQFSp6FvGQBMPeuI00n45HRqwm
    // new
    // pk_test_51NDXuOI6tTYDPEyAkkWaNjfdI63wF3zBbqvl8WiXJRGOUZJBqWx9m0eDC79BU9UkSTrSQQ8jRzgr4X5W4w2YpvT300BA2wQ361
    // sk_test_51NDXuOI6tTYDPEyAEyCxDdf0MRVPdTsm2BpmXfq7qZvvR1HMtPuhOHubv42QRTYyM08mTT0j2eXq2kjeJrmofiR000XKfNpkf8
    const stripe = await loadStripe(
      "pk_live_51NDXuOI6tTYDPEyAFnbAEJ58SkcVi1PgpaHyUjjxjPYcg6lsvo6tA9vuMUDGwZBTCEdLXxBfDX7r4FhhqgeMCfvP00dHFiYmKH"
    );

    const result = stripe.redirectToCheckout({
      sessionId: id,
    });
    setValue(false);
    if (result.error) {
      console.log(result.error);
      setValue(false);
    }
  };

  React.useEffect(() => {
    makePayment();
    setValue(false);
  }, []);

  return (
    <>
      {value ? (
        <LottieAnimation animationData={PaymentProcessing} />
      ) : (
        <div className="row justify-content-center m-0">
          <div className="col-md-8 mt-5 mb-5 cardsdetails">
            <div className="card">
              <div className="card-header bg-dark p-3">
                <div className="card-header-flex">
                  <h5 className="text-white m-0">Cart Calculation</h5>
                </div>
              </div>
              <div className="card-body p-0">
                <table className="table cart-table mb-0 table-responsive-sm">
                  <tfoot>
                    <tr>
                      <th>&nbsp;</th>
                      <th colSpan={2}>&nbsp;</th>
                      <th className="text-right">
                        Total Price<span className="ml-2 mr-2">:</span>
                        <span className="text-danger">₹1</span>
                      </th>
                      <th className="text-right">
                        <button
                          className="btn btn-success"
                          onClick={() => makePayment()}
                          type="button"
                        >
                          Checkout
                        </button>
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CartDetails;
